<template>
    <div :class="show ? 'error-msg-wrap' : 'hide'" style="width:100%">
        <div style="position:relative;width:98%;height:100%">
            <div class="pdf-pop-link" style="display:block"><a :href="link" target="_blank">Open in new tab</a></div>
            <svg @click="close()" class="remove-filter" style="background:black;border-radius:50%;width:auto;fill:white;top:-5px;right:-5px;height:32px" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.094l-4.157-4.104 4.1-4.141-1.849-1.849-4.105 4.159-4.156-4.102-1.833 1.834 4.161 4.12-4.104 4.157 1.834 1.832 4.118-4.159 4.143 4.102 1.848-1.849z"></path></svg>
            <div v-if="alreadySigned">
                <div v-if="showSign" style="width: 400px;max-width:90%;position: absolute;right:20px;bottom:0;z-index:99999;background:white">
                    <div v-if="agreeText" style="padding:5px">
                        <div v-html="agreeText" style="padding:10px;border:1px solid black;border-radius:5px;"></div>
                    </div>
                    <img :src="thisUserSignOffs[step.id].signatureData" />
                    <div style="display:flex;padding: 5px 10px">
                        <div class="btn" @click="() => { showSign = false }">Hide</div>
                    </div>
                </div>
                <div v-else style="position: absolute;right:20px;bottom:0;z-index:99999;display:flex;padding: 5px 10px">
                    <div class="btn" @click="() => { showSign = true }">View Signature</div>
                </div>
            </div>
            <div v-else>
                <div v-if="showSign" style="width: 400px;max-width:90%;position: absolute;right:20px;bottom:0;z-index:99999;background:white">
                    <div style="max-height:80vh;overflow:auto;position:relative">
                        <div v-if="agreeText" style="padding:5px">
                            <div v-html="agreeText" style="padding:10px;border:1px solid black;border-radius:5px;"></div>
                        </div>
                        <div style="height: 100px;border-bottom:1px solid black;margin:0 10px 10px"><VueSignaturePad :ref="'signaturePad'" /></div>
                        <div style="padding: 0 10px 10px"><b>Sign Name Above</b> - <a @click.prevent="() => { ($refs as any).signaturePad.clearSignature() }">Clear</a></div>
                        <div style="display:flex;padding: 5px 10px">
                            <div class="btn" @click="saveSignature" style="margin-right:10px">Submit</div>
                            <div class="btn" @click="() => { showSign = false }">Hide</div>
                        </div>
                    </div>
                </div>
                <div v-else style="position: absolute;right:20px;bottom:0;z-index:99999;display:flex;padding: 5px 10px">
                    <div class="btn" @click="() => { showSign = true }">Sign</div>
                </div>
            </div>
            <div style="width:100%;height:100%">
                <iframe style="width:100%;height:100%" :src="link" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'OnboardingPopUp',
    props: ['step', 'userSignOffs'],
    data() {
        return {
            downloadString: new Date().getTime().toString(36),
            show: false,
            link: '',
            agreeText: '',
            showSign: false,
            thisUserSignOffs: {} as any,
            alreadySigned: false
        }
    },
    created() {
        this.thisUserSignOffs = this.userSignOffs;
        if(this.thisUserSignOffs[this.step.id]) {
            this.alreadySigned = true;
        }
        this.link = this.step.link;
        if(this.step.agreeText) {
            this.agreeText = this.step.agreeText.replace(/\n/g, '<br/>');
        }
        if(!this.agreeText && this.$store.state.user.companyID == 1) {
            this.agreeText = 'I acknowledge that I have read and understand the contents of this document. I agree to comply with, uphold, and adhere to the policies, procedures, and expectations outlined herein.'
        }
        if(this.link.includes('/playbook/')) {
            let link = this.link.replace('https://', '').replace('http://', '');
            const linkSplit = link.split('?');
            link = linkSplit[0];
            const firstSlashIndex = link.indexOf('/');
            link = link.substring(firstSlashIndex, link.length) + '?hideNav=t&hideChat=t&hideComponent=t';
            if(linkSplit[1]) {
                link = link + '&' + linkSplit[1];
            }
            this.link = link;
            console.log(this.link);
        }
        this.show = true;
    },
    methods: {
        close() {
            this.$emit('close');
        },
        saveSignature() {
            const { isEmpty, data } = (this.$refs as any).signaturePad.saveSignature();
            if(isEmpty) {
                alert('Include your written signature');
                return;
            }
            this.thisUserSignOffs[this.step.id] = {
                signatureData: data
            }
            this.$emit('saveSignOffs');
            this.alreadySigned = true;
        }
    }
})
</script>